import React, { useState, useEffect } from "react";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    TextField,
    MenuItem,
    Grid,
    Paper,
    Container,
    Typography
} from '@mui/material';
import { useHistory, useParams } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import dayjs from 'dayjs';

function EditPaidReservation() {
    let history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        Monday: {
            day: "Monday",
            start_time: "",
            end_time: "",
            amount: "",
            status: "",
            restro_id: id,
            id: null
        },
        Tuesday: {
            day: "Tuesday",
            start_time: "",
            end_time: "",
            amount: "",
            status: "",
            restro_id: id,
            id: null
        },
        Wednesday: {
            day: "Wednesday",
            start_time: "",
            end_time: "",
            amount: "",
            status: "",
            restro_id: id,
            id: null
        },
        Thursday: {
            day: "Thursday",
            start_time: "",
            end_time: "",
            amount: "",
            status: "",
            restro_id: id,
            id: null
        },
        Friday: {
            day: "Friday",
            start_time: "",
            end_time: "",
            amount: "",
            status: "",
            restro_id: id,
            id: null
        },
        Saturday: {
            day: "Saturday",
            start_time: "",
            end_time: "",
            amount: "",
            status: "",
            restro_id: id,
            id: null
        },
        Sunday: {
            day: "Sunday",
            start_time: "",
            end_time: "",
            amount: "",
            status: "",
            restro_id: id,
            id: null
        }
    });

    const [initialData, setInitialData] = useState({});

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.post(endpoints.getDayWise, { restro_id: id });
            if (response.data.data) {
                const fetchedData = response.data.data.reduce((acc, dayData) => {
                    acc[dayData.day] = {
                        ...acc[dayData.day],
                        ...dayData,
                        status: dayData.status ? 'active' : 'inactive',
                    };
                    return acc;
                }, { ...formData });

                setFormData(fetchedData);
                setInitialData(fetchedData);
            }
        } catch (error) {
            console.error("Error fetching data: ", error);
        }
    };

    const onTimeChange = (newTime, day, type) => {
        setFormData({
            ...formData,
            [day]: {
                ...formData[day],
                [type]: newTime ? newTime.format('HH:mm:ss') : '',
            }
        });
    };

    const onInputChange = (e, day) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [day]: {
                ...formData[day],
                [name]: value
            }
        });
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const promises = Object.keys(formData).map(async day => {
                const { start_time, end_time, amount, status, restro_id, id } = formData[day];
                const initialDayData = initialData[day];

                if (
                    start_time !== initialDayData.start_time ||
                    end_time !== initialDayData.end_time ||
                    amount !== initialDayData.amount ||
                    status !== initialDayData.status
                ) {
                    const dataToSend = new FormData();
                    dataToSend.append("day", day);
                    dataToSend.append("start_time", start_time);
                    dataToSend.append("end_time", end_time);
                    dataToSend.append("amount", amount);
                    dataToSend.append("restro_id", restro_id);
                    dataToSend.append("status", status === 'active' ? 1 : 0);

                    if (id) {
                        dataToSend.append("id", id);
                        await axios.post(endpoints.updateDayWise, dataToSend);
                    } else {
                        await axios.post(endpoints.addDayWise, dataToSend);
                    }
                }
            });

            await Promise.all(promises);
            setLoading(false);
            toast.success("Time Schedule Submitted Successfully!");

            history.goBack();
        } catch (error) {
            console.error("Error submitting data: ", error);
            setLoading(false);
            toast.error("Error submitting data.");
        }
    };

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Weekly Schedule
            </Typography>
            <Paper elevation={3} style={{ padding: '16px', marginBottom: '16px' }}>
                <form className="ui form" onSubmit={onSubmit} encType="multipart/form-data">
                    {Object.keys(formData).map(day => (
                        <div key={day} className="mt-4">
                            <Grid container spacing={2} alignItems="center" className="px-3" style={{ padding: '5px', marginBottom: '5px' }}>
                                <Grid item xs={3}>
                                    <TextField
                                        label="Day"
                                        name="day"
                                        value={formData[day].day}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            label="Start Time"
                                            value={formData[day].start_time ? dayjs(formData[day].start_time, 'HH:mm:ss') : null}
                                            onChange={(newTime) => onTimeChange(newTime, day, 'start_time')}
                                            renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                                            views={['hours', 'minutes']}
                                            inputProps={{
                                                step: 1800, // Set step to 30 minutes
                                            }}
                                            viewRenderers={{
                                                hours: renderTimeViewClock,
                                                minutes: renderTimeViewClock,
                                                seconds: renderTimeViewClock,
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={2}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <TimePicker
                                            label="End Time"
                                            value={formData[day].end_time ? dayjs(formData[day].end_time, 'HH:mm:ss') : null}
                                            onChange={(newTime) => onTimeChange(newTime, day, 'end_time')}
                                            renderInput={(params) => <TextField {...params} variant="outlined" fullWidth />}
                                            views={['hours', 'minutes']}
                                            inputProps={{
                                                step: 1800, // Set step to 30 minutes
                                            }}
                                            viewRenderers={{
                                                hours: renderTimeViewClock,
                                                minutes: renderTimeViewClock,
                                                seconds: renderTimeViewClock,
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={2}>
                                    <TextField
                                        name="amount"
                                        label="Amount"
                                        type="number"
                                        value={formData[day].amount}
                                        variant="outlined"
                                        fullWidth
                                        onChange={(e) => onInputChange(e, day)}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <TextField
                                        label="Status"
                                        name="status"
                                        select
                                        value={formData[day].status}
                                        onChange={(e) => onInputChange(e, day)}
                                        variant="outlined"
                                        fullWidth
                                    >
                                        <MenuItem value="">
                                            <em>Select Status</em>
                                        </MenuItem>
                                        <MenuItem value="active">Active</MenuItem>
                                        <MenuItem value="inactive">Inactive</MenuItem>
                                    </TextField>
                                </Grid>
                            </Grid>
                        </div>
                    ))}
                    <div className="row ">
                        <div className="col-6 ">
                            <div className="py-3 px-2">
                                <LoadingButton
                                    type="submit"
                                    loading={loading}
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    size="large"
                                >
                                    Save
                                </LoadingButton>
                                <ToastContainer />
                            </div>
                        </div>
                    </div>
                </form>
            </Paper>
        </Container>
    );
}

export default EditPaidReservation;
